import $ from 'jquery';

const autoTabsProgress = () => {
	const el = {
		main: '.mi-vision-mision-tab .e-n-tabs',
		heading: '.mi-vision-mision-tab .e-n-tabs-heading',
		tabTitle: '.mi-vision-mision-tab .e-n-tab-title',
	};

	const DEFAULT_DURATION = 12000;

	if ($(el.main).length === 0) return;

	const init = () => {
		initAutoTabs();
	};

	const initAutoTabs = () => {
		const $tabsWidget = $(el.main);
		const duration =
			parseInt($tabsWidget.attr('data-autoplay-duration'), 10) ||
			DEFAULT_DURATION;

		const tabButtons = $tabsWidget
			.find('.e-n-tabs-heading > .e-n-tab-title')
			.toArray();

		if (tabButtons.length < 2) return;

		let timerId = null;
		let currentIndex = tabButtons.findIndex(
			(btn) => btn.getAttribute('aria-selected') === 'true',
		);
		if (currentIndex < 0) currentIndex = 0;

		const resetBar = (btn) => {
			$(btn).removeClass('is-progress-running');
			void btn.offsetWidth;
		};

		const runProgress = (index) => {
			tabButtons.forEach((btn) => resetBar(btn));

			const activeBtn = tabButtons[index];
			activeBtn.style.setProperty(
				'--tab-progress-duration',
				`${duration}ms`,
			);

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					$(activeBtn).addClass('is-progress-running');
				});
			});
		};

		const goToTab = (index) => {
			const nextIndex = (index + tabButtons.length) % tabButtons.length;
			tabButtons[nextIndex].click();
		};

		const scheduleNext = () => {
			clearTimeout(timerId);
			timerId = setTimeout(() => {
				goToTab(currentIndex + 1);
			}, duration);
		};

		tabButtons.forEach((btn, i) => {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((m) => {
					if (
						m.attributeName === 'aria-selected' &&
						btn.getAttribute('aria-selected') === 'true'
					) {
						currentIndex = i;
						runProgress(i);
						scheduleNext();
					}
				});
			});
			observer.observe(btn, { attributes: true });
		});

		runProgress(currentIndex);
		scheduleNext();
	};

	init();
};

try {
	autoTabsProgress();
} catch (error) {
	console.error('autoTabsProgress', error);
}
